var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-footer channel-action-bar"},[_c('b-btn',{staticClass:"primary-button",attrs:{"type":"primary","disabled":_vm.loading},on:{"click":function($event){return _vm.$emit('update')}}},[_vm._v("Update")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }